import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9d95418a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-7" }
const _hoisted_2 = ["src"]


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const list = [
  {
    key: 'ssg',
    image: require('../images/page-7/ssg.png'),
  },
  {
    key: 'tc',
    image: require('../images/page-7/tc.png'),
  },
  {
    key: 'tetra-park',
    image: require('../images/page-7/tetra-park.png'),
  },
  {
    key: 'logo-4',
    image: require('../images/page-7/logo-4.png'),
  }
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", null, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(list, (item, index) => {
        return _createElementVNode("li", { key: index }, [
          _createElementVNode("img", {
            src: item.image,
            class: _normalizeClass([item.key])
          }, null, 10, _hoisted_2)
        ])
      }), 64))
    ])
  ]))
}
}

})